import { AiChatMessageMode } from '@server/ai';
import type { AgentsHomeState } from './agentsHomeReducer';
import { agentsHomeInitialState } from './agentsHomeReducer';

const VALID_MODES = new Set<string>(Object.values(AiChatMessageMode));

/**
 * Sanitizes a persisted advancedMode value that may be stale or unknown
 * (any string not in {@link AiChatMessageMode}).
 */
const normalizeAdvancedMode = (value: unknown): AiChatMessageMode =>
  typeof value === 'string' && VALID_MODES.has(value) && value !== AiChatMessageMode.None
    ? (value as AiChatMessageMode)
    : AiChatMessageMode.None;

/**
 * Sanitizes a persisted list of MCP connection ids: drops anything that isn't
 * a string. Stale ids that no longer correspond to a real connection are
 * harmless — the selector code filters by the live connectors list.
 */
const normalizeConnectionIds = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((v): v is string => typeof v === 'string') : [];

/**
 * Returns the subset of AgentsHomeState to persist to localStorage,
 * with any stale values sanitized.
 */
export const agentsHomePersistedStateHandler = (state: AgentsHomeState) => ({
  ...agentsHomeInitialState,
  advancedMode: normalizeAdvancedMode(state.advancedMode),
  enabledMcpConnectionIds: normalizeConnectionIds(state.enabledMcpConnectionIds),
});
